// src/store/popupStore.ts
import { create } from "zustand"

type PopupState = {
  isOpen: boolean
  content: React.ReactNode
  position: "anchor-top" | null
  openPopup: (content: React.ReactNode, position?: "anchor-top") => void
  closePopup: () => void
}

export const usePopupStore = create<PopupState>((set) => ({
  isOpen: false,
  content: null,
  position: null,
  openPopup: (content, position) =>
    set({ isOpen: true, content, ...(position !== undefined && { position }) }),
  closePopup: () => set({ isOpen: false, content: null, position: null }),
}))
